import type { ICERObjectif } from "@bbj-types/candidate/cer";
import type { IEptRenewalFlat } from "@bbj-types/candidate/eptRenewal";
import type { ObjectId, Override } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosV2 } from "./axios";

export interface IEptRenewalChallengeBody {
  challenge: ObjectId;
  createdFromCer: boolean;
  objectives: ICERObjectif[];
  _id?: ObjectId;
  description?: string;
}

export type IEptRenewalBody = Override<
  Omit<IEptRenewalFlat, "_id" | "createdAt" | "updatedAt" | "statusTransition" | "pdfTemplate">,
  { challenges: IEptRenewalChallengeBody[] }
>;

export const usePostCandidateEptRenewal = () => {
  const [state, execute, cancel] = axiosV2<void, IEptRenewalBody, unknown>(
    {
      url: "/candidates/:id/ept/renewal",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: string, ept: IEptRenewalBody) => {
      return execute({
        url: `/candidates/${candidateId}/ept/renewal`,
        data: ept,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
